import { AddressMap } from '../types'
import { ChainId } from '../enums'

export const FLEXUSD_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72',
  // [ChainId.SMARTBCH_AMBER]: '0xFed990d491D8c563ce3d636D7536d7F9a3E2De12'
  [ChainId.SMARTBCH_AMBER]: '0xD0E6466293c6CdA8CaA96A57683909383c01411D' // mock
}

export const FACTORY_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x6008247F53395E7be698249770aa1D2bfE265Ca0',
  [ChainId.SMARTBCH_AMBER]: '0xaa094cA3FBd19dCCcE91C79d1FffA28293B05f28'
}

export const ROUTER_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x5d0bF8d8c8b054080E2131D8b260a5c6959411B8',
  [ChainId.SMARTBCH_AMBER]: '0x72a1A3F85e775dbd82D737830190aCB338fd6D71'
}

export const MISTROLL_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x719288288C7a5390206FA7F4fD51baDFd5CbF28A',
  [ChainId.SMARTBCH_AMBER]: '0x89eb9eC41015074Ffa9353b99EDd6626c2810078'
}

export const MIST_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x5fA664f69c2A4A3ec94FaC3cBf7049BD9CA73129',
  [ChainId.SMARTBCH_AMBER]: '0x3d2cd929D1fC1dA68D2557AB85336C2740b1Ae81'
}

export const MASTERCHEF_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x3A7B9D0ed49a90712da4E087b17eE4Ac1375a5D4',
  [ChainId.SMARTBCH_AMBER]: '0x5ee747274cDAc7F6CF5cD3aE2c53123BCEED59c4'
}

export const BAR_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0xC41C680c60309d4646379eD62020c534eB67b6f4',
  [ChainId.SMARTBCH_AMBER]: '0xceb95423B86c1823deC2Cc6F877997DC9349C2F1'
}

export const MAKER_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x7D1d91E59D1DA60E3ECC5701a4bc669Ab182DaE8',
  [ChainId.SMARTBCH_AMBER]: '0x6b8A569B1bA6a172d2e8Dd244282a4b16b14CaEA'
}

export const BENTOBOX_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH_AMBER]: '0x09125777d06524FE085a8478A947BC2bDD7e9ce2'
}
export const KASHI_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH_AMBER]: '0x72125F882e0Eee6821D9Cf24c160310962D3009A'
}
export const STOP_LIMIT_ORDER_ADDRESS: AddressMap = {}

export const WBCH_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04',
  [ChainId.SMARTBCH_AMBER]: '0x17F4FCF5b6E0A95D4eE331c8529041896A073F9b'
}

export const WNATIVE_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: WBCH_ADDRESS[ChainId.SMARTBCH],
  [ChainId.SMARTBCH_AMBER]: WBCH_ADDRESS[ChainId.SMARTBCH_AMBER],
}

export const MASTERCHEF_V2_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '',
  [ChainId.SMARTBCH_AMBER]: '',
}

export const ENS_REGISTRAR_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0xCfb86556760d03942EBf1ba88a9870e67D77b627',
  [ChainId.SMARTBCH_AMBER]: '0x32f1FBE59D771bdB7FB247FE97A635f50659202b',
}

export const MULTICALL2_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x3718e9C405D0bC779870355C34fb5624196A1cAA',
  [ChainId.SMARTBCH_AMBER]: '0xAF15A45d934a83b95daCFEbaACCaED8cF97e8200',
}

export const BORING_HELPER_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH_AMBER]: '0xA8eEFbCED70b77C2a717f4C6f9dA8E6Ea0Aa44eD'
}

export const SABLIER_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH]: '0x5eB85d9D7dc2F2C70F4C13b4Ba9Ed21d65141037',
  [ChainId.SMARTBCH_AMBER]: '0xeE85373F26E5380Fbd71FB7295BD68fdd0818887',
}

export const CHAINLINK_ORACLE_ADDRESS: AddressMap = {
}

export const TWAP_0_ORACLE_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH_AMBER]: "0xc6Ada1047F56ed13952d5ec8424a02ae4a41626b"
}

export const TWAP_1_ORACLE_ADDRESS: AddressMap = {
  [ChainId.SMARTBCH_AMBER]: "0x994BD855653ACCA620f3494ffA3D3696ccdCD5E4"
}
